module.exports = __webpack_public_path__ + "static/media/barbell.5804a86f.png";